var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 9.25C10.5 11.0449 9.04493 12.5 7.25 12.5C5.45507 12.5 4 11.0449 4 9.25C4 7.45507 5.45507 6 7.25 6C9.04493 6 10.5 7.45507 10.5 9.25ZM9 9.25C9 10.2165 8.2165 11 7.25 11C6.2835 11 5.5 10.2165 5.5 9.25C5.5 8.2835 6.2835 7.5 7.25 7.5C8.2165 7.5 9 8.2835 9 9.25Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 21.5C22.7165 21.5 23.5 20.7165 23.5 19.75V4.25C23.5 3.2835 22.7165 2.5 21.75 2.5H2.25C1.2835 2.5 0.5 3.2835 0.5 4.25V19.75C0.5 20.7165 1.2835 21.5 2.25 21.5H21.75ZM2.25 4C2.11193 4 2 4.11193 2 4.25V19.75C2 19.8881 2.11193 20 2.25 20H5.42803L13.9996 10.9773C14.6774 10.2638 15.81 10.2493 16.5058 10.9452L22 16.4393V4.25C22 4.11193 21.8881 4 21.75 4H2.25ZM22 19.75V18.5607L15.4451 12.0058C15.3457 11.9064 15.1839 11.9085 15.0871 12.0104L7.497 20H21.75C21.8881 20 22 19.8881 22 19.75Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMedia);
export default __webpack_public_path__ + "static/media/file-media.34f3bb87.svg";
export { ForwardRef as ReactComponent };